import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { subscriptionInitialState } from './constants';
import { ProductInfo } from './types';

const subscriptionSlice = createSlice({
  name: 'search',
  initialState: subscriptionInitialState,
  reducers: {
    saveCallbackPath: (state, action: PayloadAction<string>) => {
      state.callbackPath = action.payload;
    },
    saveProductInfo: (state, action: PayloadAction<ProductInfo>) => {
      state.productInfo = action.payload;
    },
  },
});

export const { saveCallbackPath, saveProductInfo } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
